import { SAVINGS_GUARANTEE_LAUNCH_DATE_DISPLAY, SHORT_BRANDING_NAME } from 'constants/plusMembership';
import { IMPERFECT_THEME_DOMAIN, MISFITS_THEME_DOMAIN } from 'constants/theme';
import Modal from 'honeydew/Modal';
import useBrandLinks from 'hooks/useBrandLinks';
import useGlobalStore from 'hooks/useGlobalStore';

/**
 * @param {Object} props
 * @param {boolean} props.open
 * @param {() => void} props.onClose
 * @returns {JSX.Element}
 */
function SavingsGuaranteeTermsModal({ onClose, open }) {
    const { isMisfitsTheme } = useGlobalStore();
    const { customerCare } = useBrandLinks();
    const brandDomain = isMisfitsTheme ? MISFITS_THEME_DOMAIN : IMPERFECT_THEME_DOMAIN;
    const plusMembershipShortBranding = SHORT_BRANDING_NAME[brandDomain];

    return (
        <Modal open={open} onClose={onClose} headline="Savings Guarantee Terms">
            <p className="text-body-sm text-grey">
                The {plusMembershipShortBranding} Savings Guarantee is available to eligible customers who started a new{' '}
                {plusMembershipShortBranding} membership, or renewed an existing membership, on or after{' '}
                {SAVINGS_GUARANTEE_LAUNCH_DATE_DISPLAY}. If your total {plusMembershipShortBranding} savings during your
                membership year (based on the combined item and shipping savings for the applicable membership year as
                calculated in your {plusMembershipShortBranding} savings tracker) are less than the membership fee you
                actually paid, you may request a credit for the difference within 30 days after your membership renewal
                or expiration date by contacting our Customer Care team{' '}
                <a className="underline" href={customerCare} target="_blank" rel="noopener noreferrer">
                    here
                </a>
                . Savings Guarantee will be fulfilled as a credit added to your {plusMembershipShortBranding} account
                that will automatically apply to your future orders, whether or not you renew or cancel your{' '}
                {plusMembershipShortBranding} membership. Credits will be applied to your account within approximately
                ten (10) business days. Credits are subject to the {plusMembershipShortBranding} Terms of Service and
                are promotional in nature, are not transferable, are not redeemable for cash or other property, and are
                subject to certain limitations and restrictions as further described in the{' '}
                {plusMembershipShortBranding} Terms of Service. Savings Guarantee limited to a maximum of one credit per
                membership year. Savings calculations do not include cancelled, returned, or refunded products or
                orders. {plusMembershipShortBranding} calculates your savings based on its records and will determine
                credit eligibility and amounts in its reasonable discretion. {plusMembershipShortBranding} reserves the
                right to withhold credits in cases of suspected fraud or abuse and may modify or discontinue this
                Savings Guarantee at any time (without affecting membership years already completed) with or without
                notice to you.
            </p>
        </Modal>
    );
}

export default SavingsGuaranteeTermsModal;
